module.exports = __webpack_public_path__ + "img/about-shape-2.8303b2fe.svg";